import React, { useState, useEffect } from 'react';
import api from '../api/api';
import Spinner from '../Spinner';
import ButtonLoading from './ButtonLoading';

const Register = () => {
    const [email, setEmail] = useState('');
    const [password1, setPassword1] = useState('');
    const [password2, setPassword2] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [thanksMessage, setThanksMessage] = useState('');
    const [activationMessage, setActivationMessage] = useState('');
    const [deleteSpineer, setDeleteSpinner] = useState(false);
    const messageDisplaySpeed = 20; // 表示スピード（ミリ秒）
    const [showTooltip, setShowTooltip] = useState(false);

    useEffect(() => {
        if (success) {
            // 「ご登録ありがとうございます！」をカタカタ表示
            typeMessage('ご登録ありがとうございます！', setThanksMessage, () => {
                // 次に「アクティベーションメールが送信されました。」を表示
                setTimeout(() => {
                    typeMessage('アクティベーションメールが送信されました。メールを確認し、アカウントを有効化してください。', setActivationMessage);
                }, 20); // 1秒の遅延を追加
            });
            setDeleteSpinner(true);
        }
    }, [success]);

    const typeMessage = (message, setMessage, callback) => {
        let index = 0;
        const interval = setInterval(() => {
            setMessage(prev => prev + message[index]);
            index++;
            if (index === message.length - 1) {
                clearInterval(interval);
                if (callback) callback(); // メッセージが全て表示されたら次のアクションを実行
            }
        }, messageDisplaySpeed);
    };

    const handleRegisterClick = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setSuccess('');
        setThanksMessage('');
        setActivationMessage('');

        try {
            const response = await api.post(`${process.env.REACT_APP_API_URL}/accounts/api/register/`, {
                email: email,
                password1: password1,
                password2: password2
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            setSuccess("登録が成功しました。確認メールを送信しました。");
        } catch (error) {
            if (error.response && error.response.data) {
                setError(error.response.data.email || error.response.data.password1 || error.response.data.password2 || "エラーが発生しました。");
            } else {
                setError("サーバーエラーが発生しました。");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='background'>
            {success ? 
                <div className="activation">
                    <div className="user-main-contents">
                        <div className="message-sender">
                            <img src="img/chat_logo.png" alt="Profile Picture" className="icon h-[25px] w-[25px]" />
                            {!deleteSpineer && < Spinner />}
                        </div>
                        <div id="message">
                            {/* カタカタ表示されるメッセージ */}
                            <p id="thanks-message">{thanksMessage}</p>
                            <p id="activation-message">{activationMessage}</p>
                        </div>
                    </div>
                </div>
                :
                <>
                    <div className="form-main">
                        <h1>ユーザ登録 (無料)</h1>
                        
                        <p id="user-registration-confirmation">ユーザ登録の前に <a href="term-of-use/">利用規約</a> をご確認ください。
                            <br/>
                            ユーザ登録すると利用規約に同意したものとします。</p>

                            {/* エラーメッセージ */}
                            {error && <p style={{ color: 'red' }}>{error}</p>}

                            <form onSubmit={handleRegisterClick}>
                                <input 
                                    className="user-input"
                                    type="email" 
                                    name="email" 
                                    placeholder="メールアドレス" 
                                    maxLength="320" 
                                    required 
                                    id="id_email" 
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                <input 
                                    className="user-input"
                                    type="password" 
                                    name="password" 
                                    placeholder="パスワード" 
                                    required 
                                    id="id_password" 
                                    value={password1}
                                    onChange={(e) => setPassword1(e.target.value)}
                                />
                                <input 
                                    className="user-input"
                                    type="password" 
                                    name="confirm_password" 
                                    placeholder="パスワード確認用" 
                                    required 
                                    id="id_confirm_password"
                                    value={password2}
                                    onChange={(e) => setPassword2(e.target.value)}
                                />
                                <button type="submit" className="btn" disabled={loading}>{loading ? <ButtonLoading /> : "登録"}</button>
                            </form>

                            <div id="" className="mb-4 relative">
                                <div onMouseEnter={()=>setShowTooltip(true)} onMouseLeave={()=>setShowTooltip(false)}>
                                    <a id="password-forget" href="/analysis">ユーザ登録せずに利用する</a>
                                </div>
                                {showTooltip && 
                                    <div className='absolute top-[25px] right-[50px] bg-[#1EA8ADCC] text-white rounded-md align-center py-2 px-4'>
                                        ダッシュボードの閲覧が可能です
                                    </div>
                                }
                            </div>
                            
                            {/* ログインへのリンク */}
                            <div className="div-to-login">
                                <a className="to-login" href="/login/">ログインはこちら</a>
                            </div>
                    </div>
                </>
            }
        </div>
    );
};

export default Register;
